(function($) {
	if( $('#weather').length ) {
		var widget = $('#weather');

		// var query = "SELECT * FROM weather.forecast WHERE woeid='12794145'";
		// var cacheBuster = Math.floor((new Date().getTime()) / 1200 / 1000);
		//
		// var url = 'https://query.yahooapis.com/v1/public/yql?q='+encodeURIComponent(query)+'&format=json&_nocache='+cacheBuster;

		widget.addClass('loading').find('.temp').text('Loading weather');
		var weather_url = '/ajax/weather';
		$.ajax({
			url: weather_url,
			dateType: 'json',
			cache: true,

			success: function(data) {
				// console.log('success');
				var results = JSON.parse(data);
				// console.log(results.weather[0].icon);
				var icode = ['01d','01n','02d','02d','03d','03n','04d','04n','09d','09n','10d','10n','11d','11n','13d','13n','50d','50n'];
				var iconfont = ['32','31','33','34','28','28','28','28','19','19','40','40','37','37','41','41','1','1'];
				var id = icode.indexOf(results.weather[0].icon );

                // console.log(iconfont[id]);
                // (32°F − 32) × 5/9 = 0°C
                var temp = results.main.temp;
                var tempmetric = (results.main.temp - 32) * (5/9);
                var temperature = Math.round(temp) +'<sup>&deg; F</sup> / ' + Math.round(tempmetric) +'<sup>&deg; C</sup> ';
				var weatherIcon = '<span class="weather-icon weather-'+ iconfont[ id ] +'"></span>';
				//
				widget.removeClass('loading').addClass('loaded')
					.find('.temp').html(temperature);
				widget.find('#weather-icon').html(weatherIcon);
			},
			error: function(data) {
				widget.removeClass('loading').addClass('not-loaded').find('.temp').html('There was an error.');
			},
			complete: function(data) {
				if( widget.is(':not(.loaded)')) {
					widget.removeClass('loading').find('.temp').html('Click here for forecast.');
				}
			}
		});
	}
})(jQuery);
